// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"style__iconContainer__-+t8c"};